<template>
    <div>

        <Head title="Reporte" />
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-sky-400 hover:text-sky-600" href="/orders">Pedidos</Link>
            <span class="text-sky-400 font-medium">/</span> Reporte
        </h1>

        <!-- Contenedor principal -->
        <div class="max-w-7xl mx-auto bg-white rounded-lg shadow-lg p-6">
            <!-- Fecha del reporte -->
            <div class="mb-6 flex justify-between">
                <h2 class="text-2xl font-semibold">Órdenes del día: {{ reportData.date }}</h2>
                <button @click="descargarPDF()"
                    class="px-4 py-3.5 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300">
                    Imprimir Reporte
                </button>
            </div>

            <div class="bg-gradient-to-r from-sky-500 to-sky-600 p-6 rounded-xl shadow-lg mb-2">
                <div class="grid grid-cols-2 md:grid-cols-3 gap-4 text-white">
                    <!-- <InfoCard title="Tiendas visitadas" :value="reportData.storeVisited"
                    :image="getIconUrl('markerBlue.png')" /> -->
                    <div class="bg-white bg-opacity-20 p-4 rounded-lg backdrop-blur-lg">
                        <h3 class="text-sm font-medium text-white text-opacity-80">Tiendas visitadas</h3>
                        <div class="flex justify-between items-center">
                            <div class="font-bold text-white mt-1">
                                <span class="text-xl">{{ reportData.storeVisited }} abiertas</span> <br>
                                <span class="text-xl">{{ reportData.storeClosed }} cerradas</span> <br>
                            </div>
                            <p>
                            <div class="bg-white rounded-lg p-1">
                                <img :src="getIconUrl('icon_open_store.png')" class="w-6 h-6 object-contain"
                                    alt="total" />
                            </div>
                            </p>
                        </div>
                    </div><!--end infocard custom-->
                    <InfoCard title="Tiendas no visitadas" :value="reportData.storeNotVisited"
                        :image="getIconUrl('markerRed.png')" />
                    <InfoCard title="Cantidad de pedidos" :value="reportData.totalOrders"
                        :image="getIconUrl('markerStore.png')" />
                    <InfoCard title="Total de cajas" :value="reportData.grandTotal.boxes"
                        :image="getIconUrl('box.png')" />
                    <InfoCard title="Total de piezas" :value="reportData.grandTotal.pieces"
                        :image="getIconUrl('box.png')" />
                    <InfoCard title="Total en Efectivo" :value="formatPrice(reportData.grandTotal.amount)"
                        :image="getIconUrl('markerStore.png')" />
                </div>
            </div>
            <!-- Rutas -->
            <div v-for="(routeData, routeName) in reportData.routeTotals" :key="routeName" class="mb-8">
                <!-- Encabezado de Ruta -->
                <div class="bg-gradient-to-r from-gray-500 to-gray-600 p-6 rounded-xl shadow-lg mb-2 dark:bg-gray-500">
                    <div class="grid grid-cols-2 md:grid-cols-3 gap-4 text-white">
                        <InfoCard title="RUTA" :value="routeName" :image="getIconUrl('icon_path.png')" />
                        <div class="bg-white bg-opacity-20 p-4 rounded-lg backdrop-blur-lg">
                            <h3 class="text-sm font-medium text-white text-opacity-80">TIENDAS VISITDAS</h3>
                            <div class="flex justify-between items-center">
                                <div class="font-bold text-white mt-1">
                                    <span class="text-xl">{{ routeData.visitedStores.length }} abiertas</span> <br>
                                    <span class="text-xl">{{ routeData.closedStores.length }} cerradas</span> <br>
                                </div>
                                <p>
                                <div class="bg-white rounded-lg p-1">
                                    <img :src="getIconUrl('icon_open_store.png')" class="w-6 h-6 object-contain"
                                        alt="total" />
                                </div>
                                </p>
                            </div>
                        </div><!--end infocard custom-->
                        <InfoCard title="TIENDAS NO VISITADAS" :value="routeData.notVisitedStores.length"
                            :image="getIconUrl('icon_not_open_store.png')" />
                        <InfoCard title="CAJAS" :value="routeData.boxes" :image="getIconUrl('box.png')" />
                        <InfoCard title="PIEZAS" :value="routeData.pieces" :image="getIconUrl('piece.png')" />
                        <InfoCard title="TOTAL EN RUTA" :value="formatPrice(routeData.amount)"
                            :image="getIconUrl('cash.png')" />
                    </div>
                </div>

                <!-- Tiendas de la Ruta -->
                <div v-for="store in routeData.stores" :key="store.id"
                    class="mb-6 bg-white rounded-lg border border-gray-200">
                    <!-- Información de la Tienda -->
                    <div class="p-4 bg-gray-50 border-b">
                        <div class="flex justify-between">
                            <h3 class="font-bold text-lg">Tienda: {{ store.name }}</h3>
                            <h3 class="font-bold text-lg">
                                Tipo de pago: {{ store.purchase_type === 1 ? 'CONTADO' : (store.purchase_type === 2 ?
                                'CRÉDITO' : '') }}
                            </h3>
                            <h4 class="font-bold text-lg">
                                Requiere factura: {{ store.invoice_required == 1 ? 'SI' : 'NO' }}
                            </h4>
                            <h3 class="font-bold text-lg">{{ store.folio ?? '0000000' }}</h3>
                        </div>
                        <p class="text-gray-600">Dirección: {{ store.address }}</p>
                        <p v-if="store.details_visit" class="text-gray-700 mt-2">
                            Observaciones: {{ store.details_visit }}
                        </p>
                    </div>

                    <!-- Tabla de Productos -->
                    <div class="overflow-x-auto">
                        <table class="w-full">
                            <thead>
                                <tr class="bg-gray-50">
                                    <th class="px-4 py-2 text-left">Producto</th>
                                    <th class="px-4 py-2 text-right">Precio</th>
                                    <th class="px-4 py-2 text-center">Cantidad</th>
                                    <th class="px-4 py-2 text-right">Descuento</th>
                                    <th class="px-4 py-2 text-right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="product in store.products" :key="product.name" class="border-t">
                                    <td class="px-4 py-2">{{ product.name }}</td>
                                    <td class="px-4 py-2 text-right">{{ formatPrice(product.price) }}</td>
                                    <td class="px-4 py-2 text-center">{{ product.amount }}</td>
                                    <td class="px-4 py-2 text-right">
                                        {{ product.discount ? formatPrice(product.discount) : 'N/A' }}
                                    </td>
                                    <td class="px-4 py-2 text-right">{{ formatPrice(product.total) }}</td>
                                </tr>
                                <!-- Total de la Tienda -->
                                <tr class="border-t bg-gray-50 font-bold">
                                    <td colspan="4" class="px-4 py-2 text-right">Total</td>
                                    <td class="px-4 py-2 text-right">{{ formatPrice(store.total) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Total General al final -->
            <div class="bg-gray-100 p-4 rounded-lg mt-6">
                <div class="grid grid-cols-4 gap-4">
                    <div class="text-gray-700 font-bold">Total General</div>
                    <div class="text-gray-700">Total de Cajas: {{ reportData.grandTotal.boxes }}</div>
                    <div class="text-gray-700">Total de Piezas: {{ reportData.grandTotal.pieces }}</div>
                    <div class="text-gray-700 text-right font-bold">
                        Total en Efectivo: {{ formatPrice(reportData.grandTotal.amount) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import InfoCard from '@/Shared/InfoCard'

export default {
    components: {
        Head,
        Link,
        Icon,
        InfoCard,
    },
    layout: Layout,
    props: {
        reportData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                order_date: '',
            }),
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/orders/report', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        formatPrice(amount) {
            return new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN'
            }).format(amount)
        },
        formatDate(originalDate) {
            const formattedDate = new Date(originalDate);
            return formattedDate.toLocaleString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        },
        descargarPDF() {
            const [day, month, year] = this.reportData.date.split('/');
            const formattedDate = `${year}-${month}-${day}`;
            const id_employee = this.reportData.id_employee;
            // window.location.href = '/generar-pdf';  
            if (id_employee > 0) {
                window.location.href = `/generar-pdf/employee/${formattedDate}/${id_employee}`;
            } else {
                window.location.href = `/generar-pdf/${formattedDate}`;
            }
        },
        getIconUrl(image) {
            // Adjust this path according to your project structure
            return `/img/${image}`
        },
    }
}
</script>